var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGenderFemaleRegular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.717 5.533a6.25 6.25 0 1 0-8.839 8.839 6.25 6.25 0 0 0 8.84-8.84m-9.9-1.06a7.75 7.75 0 1 1 10.96 10.96 7.75 7.75 0 0 1-10.96-10.96",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.878 14.372a.75.75 0 0 1 0 1.06L5.282 20.03a.75.75 0 0 1-1.06-1.061l4.596-4.596a.75.75 0 0 1 1.06 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.691 14.195a.75.75 0 0 1 1.06 0l5.304 5.303a.75.75 0 1 1-1.06 1.06L3.69 15.257a.75.75 0 0 1 0-1.061",
  clipRule: "evenodd"
})));
export default SvgIcGenderFemaleRegular;